import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { RevealContext } from './reveal.context';
/**
 * A component for revealing/hiding content.
 */
export const RevealContainer = ({ children, defaultRevealId, }) => {
    const [activeReveal, setActiveReveal] = useState(defaultRevealId);
    // For async data loading, update the default reveal id once done.
    useEffect(() => {
        setActiveReveal(defaultRevealId);
    }, [defaultRevealId]);
    const revealContext = {
        activeReveal,
        setActiveReveal,
    };
    return (_jsx(RevealContext.Provider, { value: revealContext, children: children }));
};
//# sourceMappingURL=reveal.js.map